import clientConfigApi from '../config/config'
import axios from 'axios';
import { token } from '../config/constant';
import Api from '../config/constant'

export const fetchMusicGenres = () => {
  const path =  "apps/genrelist/fetch"
  
  return async (dispatch) => {
    try {

      const { data = {} } = await clientConfigApi.put(path);
      
   
      if (data.payload) {
        dispatch({ type: 'Music_Genre_List', payload: data.payload });
      } else {
        dispatch({ type: 'Music_Genre_List', payload: [] }); 
      }

    } catch (error) {
      dispatch({ type: 'Music_Genre_List', payload: [] });
      console.error("Error in fetchMusicGenres API:", error);
    } finally {

    }
  };
};


export const fetchData = (path) => {
  return async dispatch => {
    let { data = {} } = await Api.get(
      path
    )
      .catch(
        ({ response = {} }) => {
          console.log("Api failed with the status code:", response.status)
        }
      )
    //console.log("response data profile data:",responseData)
    if (data) {
      if (path === "/musicList") {
        dispatch({
          type: 'Fetch_Music_Data',
          payload: data
        }
        );
      }
    }
  }
}

export const setCurrentPlaylist = (currentPlaylist) => {
  return {
    type: 'Set_Playlist',
    payload: currentPlaylist
  }
}

export const setGoToCurrentPlayList = (bool) => {
  return {
    type: 'Go_To_Current_Playlist',
    payload: bool
  }
}

export const setMusicConfig = (updatedConfig) => {
  return {
    type: "Set_Music_Config",
    payload: updatedConfig
  }
}

export const setCurrentSong = (song) => {
  return {
    type: 'Music_Set_Current_Song',
    payload: song
  }
}

export const isPlayingInBackground = (data) => {
  return {
    type: 'Music_Set_Background_Play',
    payload: data
  }
}

export const fetchSong = (path) => {
  return async (dispatch) => {
    try {
      
      const { data = {} } = await clientConfigApi.put(path);
      
      if (data.payload && data.payload.songList && data.payload.songList.length > 0) {
        dispatch({
          type: 'Music_List',
          payload: data.payload.songList,
        });
        
      } else {
        console.warn("No song list found in response.");
        dispatch({ type: 'Music_List', payload: [] }); 
      }

    } catch (error) {
      console.error("Error in fetchSong API:", error);
      dispatch({ type: 'Music_List', payload: [] }); 
    } finally {

    }
  };
};
